
document.addEventListener("DOMContentLoaded", function () {
  const toc = document.getElementById("toc");
  if (!toc) return;

  // Find the actual article content wrapper
  const content =
    document.querySelector(".m-article-content") ||
    document.querySelector(".article__content") ||
    document.querySelector(".article-content") ||
    document.querySelector(".rte");

  if (!content) {
    toc.style.display = "none";
    return;
  }

  /* ==========================================
     POSITION TOC AFTER QUICK ANSWER
     ========================================== */

  const quickAnswer = content.querySelector(
    ".sodpods-quick-answer"
  );

  // Move the TOC directly below Quick Answer
  if (quickAnswer) {
    quickAnswer.insertAdjacentElement("afterend", toc);
  }

  /* ==========================================
     GENERATE TABLE OF CONTENTS
     ========================================== */

  // H2 only - exclude Quick Answer headings
  const headings = Array.from(
    content.querySelectorAll("h2")
  ).filter((heading) => {
    return (
      !heading.closest(".sodpods-quick-answer") &&
      !heading.closest("#toc")
    );
  });

  if (!headings.length) {
    toc.style.display = "none";
    return;
  }

  toc.style.display = "block";

  toc.innerHTML = `
    <div class="m-toc__title">Table of contents</div>
  `;

  const ul = document.createElement("ul");
  ul.className = "m-toc__list";

  // Generate clean heading IDs
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  headings.forEach((h, index) => {
    const text = (h.textContent || "").trim();
    if (!text) return;

    // Add an ID if missing
    if (!h.id) {
      h.id = `toc-${index}-${slugify(text)}`;
    }

    const li = document.createElement("li");
    li.className = "m-toc__h2";

    const a = document.createElement("a");
    a.href = `#${h.id}`;
    a.textContent = text;

    li.appendChild(a);
    ul.appendChild(li);
  });

  toc.appendChild(ul);
});
